// export const environment = {
//   production: true,
//   supabaseUrl: 'http://127.0.0.1:54321',
//   supabaseAnonKey: 'sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH',
//   supabaseApi: 'http://127.0.0.1:54321/rest/v1',
//   api: 'http://127.0.0.1:54321/rest/v1/',
//   universal_preview_iframe: 'http://localhost:4302/',
//   consoleApi: 'http://localhost:3001/api',
//   survey_api_url:'http://localhost:3232/api',
//   survey_api_media_bucket:'survey-upload-assets',
//   interviewer_api: 'http://localhost:3233/api',
//   sigma_exporter_api: 'http://127.0.0.1:5000/api'
// };


export const environment = {
  production: true,
  supabaseUrl: 'https://api-v1.infersurveys.com',
  supabaseAnonKey:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzdXBhYmFzZSIsImlhdCI6MTc3NDkyMzQ4MCwiZXhwIjo0OTMwNTk3MDgwLCJyb2xlIjoiYW5vbiJ9.xrycLVJzqKDzKgSWnVnVY8o-lXziFP4-ix1KGJyTARQ',
  supabaseApi: 'https://api-v1.infersurveys.com/rest/v1',
  api: 'https://api-v1.infersurveys.com/rest/v1/',
  universal_preview_iframe: 'https://console-preview.infersurveys.com/',
  consoleApi: 'https://console-api.infersurveys.com/api',
  survey_api_url: 'https://survey-api.infersurveys.com/api',
  survey_api_media_bucket: 'survey-upload-assets',
  interviewer_api: 'https://interviewer-api.infersurveys.com/api',
  sigma_exporter_api: 'https://data-api.infersurveys.com/api',
  supersetUrl_api: '',
};